import { CheckCircle2, UserRound, Store } from "lucide-react";

const INVESTORS = [
  "Every opportunity is pre-vetted and underwritten by frantiger before it lists",
  "Subscribe to fractions from ₹5,000 — issued as CCD / NCD private debt instruments",
  "Debt sits ahead of operator equity, with a disciplined 60:40 capital structure",
  "Real secondary liquidity — exit via Offer to Sell, scale via Offer to Buy (flat ₹100 / trade)",
  "Monthly coupon payouts with transparent digital sales reporting",
];

const BRANDS = [
  "frantiger structures your raise for a 5% Annual Management Charge (AMC) — no heavy bank loans or EMI stress",
  "Raise the 40% pool from up to 200 verified investors per franchise unit",
  "Every unit gets a unique 6-letter scrip ID for clean, traceable participation",
  "Convert hundreds of co-investors into loyal brand ambassadors",
  "Keep full operational control by holding 60% of the capital stack",
];

const Panel = ({ icon: Icon, title, items, testid }) => (
  <div className="glass-dark rounded-[2rem] p-8" data-testid={testid}>
    <div className="flex items-center gap-3">
      <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-orange-500 text-white shadow-lg shadow-orange-500/40">
        <Icon className="h-5 w-5" />
      </span>
      <h3 className="font-heading text-xl font-extrabold text-white sm:text-2xl">{title}</h3>
    </div>
    <ul className="mt-6 space-y-4">
      {items.map((item) => (
        <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-slate-300">
          <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-orange-400" />
          {item}
        </li>
      ))}
    </ul>
  </div>
);

export default function Benefits() {
  return (
    <section id="for-brands" data-testid="dual-benefits-section" className="relative overflow-hidden bg-slate-900 py-24">
      <div className="pointer-events-none absolute -left-32 top-0 h-96 w-96 rounded-full bg-orange-500/15 blur-3xl" />
      <div className="pointer-events-none absolute -right-32 bottom-0 h-96 w-96 rounded-full bg-orange-500/10 blur-3xl" />
      <div className="relative mx-auto max-w-6xl px-4">
        <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end">
          <div className="max-w-xl">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-400">Why fraction wins</p>
            <h2 className="font-heading mt-4 text-2xl font-extrabold tracking-tight text-white sm:text-3xl lg:text-4xl">
              Built for investors. Loved by franchise brands.
            </h2>
          </div>
          <img src="/assets/frantiger_logo_white.png" alt="frantiger white logo" className="h-8 w-auto opacity-90" data-testid="benefits-white-logo" />
        </div>
        <div className="mt-12 grid gap-7 lg:grid-cols-2">
          <Panel icon={UserRound} title="For Investors" items={INVESTORS} testid="benefits-investors-panel" />
          <Panel icon={Store} title="For Franchise Brands" items={BRANDS} testid="benefits-brands-panel" />
        </div>
      </div>
    </section>
  );
}
